import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import { getAdminMenuList } from '../../common/menuHelper';
import { useSelector } from "react-redux";
import { selectSessionContextOidc } from '@container/AdminPanel/features/users/usersSelectors';

const LeftNav = () => {
  const location = useLocation();
  const sessionContext= useSelector(selectSessionContextOidc);
  const menuItems = getAdminMenuList(sessionContext?.userView?.permissions);
  return (
    <div className="admin__left_nav">
      <ul className="colFlex">
        {menuItems.map((item, index) => {
          const isActive = location.pathname === item.path || location.pathname.startsWith(`${item.path}/`);

          return (
            <li key={index} className={isActive ? "active" : ""}>
              <NavLink to={item.path} data-test={item.dataTest}>
                {item.name}
              </NavLink>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default LeftNav;
